var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      attrs: {
        title: _vm.formData.id ? "修改赛事" : "添加赛事",
        visible: _vm.dialogFormVisible,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.rewriteClearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: {
            rules: _vm.rules,
            model: _vm.formData,
            "label-width": "100px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "name", label: "名称" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: { autocomplete: "off", placeholder: "请输入" },
                model: {
                  value: _vm.formData.name,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "name", $$v)
                  },
                  expression: "formData.name"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "age_group", label: "年龄组" }
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.formData.age_group,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "age_group", $$v)
                    },
                    expression: "formData.age_group"
                  }
                },
                _vm._l(_vm.ageGroupList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.age_group, value: item.age_group }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "searchDateArr", label: "选择时间" }
            },
            [
              _c("el-date-picker", {
                ref: "datePicker",
                attrs: {
                  clearable: "",
                  "value-format": "yyyy-MM-dd",
                  type: "daterange",
                  align: "right",
                  "range-separator": "至",
                  "start-placeholder": "开始时间",
                  "end-placeholder": "结束时间",
                  "picker-options": _vm.pickerOptions
                },
                on: { change: _vm.seachDateChange },
                model: {
                  value: _vm.formData.searchDateArr,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "searchDateArr", $$v)
                  },
                  expression: "formData.searchDateArr"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "entry_fee", label: "报名费用" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: { autocomplete: "off", placeholder: "请输入" },
                model: {
                  value: _vm.formData.entry_fee,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "entry_fee", $$v)
                  },
                  expression: "formData.entry_fee"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "最大球队", prop: "max_teams" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: { autocomplete: "off", placeholder: "请输入" },
                model: {
                  value: _vm.formData.max_teams,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "max_teams", $$v)
                  },
                  expression: "formData.max_teams"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "format", label: "赛制规则" }
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.formData.format,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "format", $$v)
                    },
                    expression: "formData.format"
                  }
                },
                _vm._l(_vm.formatList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { prop: "tournament_type", label: "赛制类型" }
            },
            [
              _c(
                "el-select",
                {
                  staticClass: "flex-1",
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.formData.tournament_type,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "tournament_type", $$v)
                    },
                    expression: "formData.tournament_type"
                  }
                },
                _vm._l(_vm.tournamentTypeList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { width: "100%" } },
            [
              _c(
                "el-form-item",
                { staticClass: "lodingItem", attrs: { prop: "" } },
                [
                  _c("el-button", { attrs: { type: "primary" } }, [
                    _vm._v("积分规则配置")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              staticStyle: { width: "100%" },
              attrs: { prop: "scoreGroup" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    width: "100%",
                    display: "flex",
                    "flex-wrap": "wrap"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      staticStyle: { "margin-right": "27px" },
                      attrs: { prop: "", label: "胜利" }
                    },
                    [
                      _c("el-input", {
                        staticClass: "flex-1",
                        attrs: { placeholder: "请填写", autocomplete: "off" },
                        model: {
                          value: _vm.formData.win,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "win", $$v)
                          },
                          expression: "formData.win"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: { prop: "", label: "平局" }
                    },
                    [
                      _c("el-input", {
                        staticClass: "flex-1",
                        attrs: { placeholder: "请填写", autocomplete: "off" },
                        model: {
                          value: _vm.formData.draw,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "draw", $$v)
                          },
                          expression: "formData.draw"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: { prop: "", label: "失败" }
                    },
                    [
                      _c("el-input", {
                        staticClass: "flex-1",
                        attrs: { placeholder: "请填写", autocomplete: "off" },
                        model: {
                          value: _vm.formData.loss,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "loss", $$v)
                          },
                          expression: "formData.loss"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              staticStyle: { width: "100%" },
              attrs: { prop: "description", label: "简介" }
            },
            [
              _c("el-input", {
                staticClass: "flex-1",
                attrs: {
                  type: "textarea",
                  placeholder: "请填写",
                  autocomplete: "off"
                },
                model: {
                  value: _vm.formData.description,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "description", $$v)
                  },
                  expression: "formData.description"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "" },
              on: {
                click: function($event) {
                  return _vm.dataFormSubmit()
                }
              }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }